import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Moment from 'moment';
import VideoOrImage from '../VideoOrImage';
import Currency from '../Currency';
import Button from '../Button';
import { LAYOUT } from '../Layout/enums';
import Tooltip from '../Tooltip';
import DefaultLogo from '../../assets/images/no_logo.png';
import notice from '../../assets/images/notice.svg';
import './OfferMain.css';
import { offeringCategory } from '../../helpers/mappings';
import ComingSoonLabel from '../ComingSoonLabels';
import OfferIndicateInterest from './OfferIndicateInterest';
import BaseModal from '../BaseModal';
import CloseIcon from '../../assets/images/close_gray.svg';

const ClosedOfferStats = ({ styleSuff, offering, noShowFields }) => (
  <div styleName={`videoRight${styleSuff}`}>
    <div styleName="offerStatContainer">
      <div styleName="offerClosed">
        Offer Closed
      </div>
      {offering.yield && !noShowFields.includes('yield') ? (
        <div styleName="closedOfferYieldBox">
          <YieldLabel />
          <div styleName="closedYieldStat">{offering.yield || '--'}</div>
        </div>
        ) : null }
      {offering.subTextOnClosed &&
      (
      <div styleName="closedOfferYieldBox">
        <span>{offering.subTextOnClosed.split('\n').map(text => <Fragment>{text}<br /></Fragment>)}</span>
      </div>
      )
      }
    </div>
  </div>
);

const YieldLabel = () => (
  <div styleName="yield">
    <div styleName="yieldLabel">
      Annual Yield
    </div>
    <Tooltip text="Yield is a return on an investment in the form of interest or dividends." />
  </div>
);


const allowInvestment = (offering, postCloseInvestmentsAllowedIn) => {
  const isActive = offering.status.toLowerCase() === 'active';
  const isClosed = offering.status.toLowerCase() === 'closed';
  const isPostCloseInvestmentAllowed = postCloseInvestmentsAllowedIn && postCloseInvestmentsAllowedIn.includes(offering.id);
  return isActive || (isClosed && isPostCloseInvestmentAllowed);
};

export class StatsAndInvest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDisclaimerDialog: false,
    };
  }

  handleDisclaimerDialog = () => {
    this.setState({ showDisclaimerDialog: !this.state.showDisclaimerDialog });
  }

  render() {
    const { offering, styleSuff, postCloseInvestmentsAllowedIn } = this.props;
    const noShowFields = _.isEmpty(offering.nonVisibleAppFields) ? [] : offering.nonVisibleAppFields.map(field => field.fieldName);
    const nonFolio = offering.isExternalOffer;
    if (offering.status.toLowerCase() === 'closed' && (!postCloseInvestmentsAllowedIn || !postCloseInvestmentsAllowedIn.includes(offering.id))) {
      return (
        <div style={{ width: '35%' }}>
          <ClosedOfferStats
            styleSuff={styleSuff}
            offering={offering}
            noShowFields={noShowFields}
          />
        </div>
      );
    }
    const closingMsg = offering.recurring ? 'next closing ' : 'closing';
    // eslint-disable-next-line no-nested-ternary
    const daysUntilClosing = offering.closeDate ? Moment.isMoment(offering.closeDate) ? Moment(offering.closeDate).diff(Moment(), 'days') : offering.closeDate : null;
    const {
      minimumInvestCurrencyAmt,
    } = offering;
    let actionControl;
    if (offering.category === offeringCategory.COMING_SOON.value || offering.category === offeringCategory.TESTING_WATERS.value) {
      actionControl = (
        <div>
          <OfferIndicateInterest
            offering={offering}
            styleSuff={styleSuff}
          />
        </div>
      );
    } else if (allowInvestment(offering, postCloseInvestmentsAllowedIn)) {
      actionControl = (
        <Fragment>
          {daysUntilClosing > 0 ? (
            <div styleName="offerStatContainer">
              <div styleName="closingDate">{`Days until ${closingMsg}`}</div>
              <div styleName="daysUntilClosing">{daysUntilClosing}</div>
            </div>
          ) : null}
          <div styleName={`investBtn${styleSuff}`}>
            <Button to={nonFolio ? `/external-invest/${offering.id}` : `/invest/${offering.id}`}>Invest</Button>
          </div>
        </Fragment>
      );
    } else {
      actionControl = (
        <div styleName="offerClosed">
          Offer Closed
        </div>
      );
    }
    const currency = !offering.minimumInvestCurrencyAmt ? (
      <div
        style={{
          'letter-spacing': '0.4px',
          'font-family': '"Source Sans Pro", sans-serif',
          'text-align': 'left',
          'font-size': '23px',
          'font-weight': 'bold',
        }}
      >
        N/A
      </div>) : (
        <Currency styleName="minInvAmt" amount={Number(minimumInvestCurrencyAmt)} hideCents />
    );
    function buttonize(handlerFn) {
      return {
        role: 'button',
        onClick: handlerFn,
      };
    }
    return (
      <div styleName={`videoRight${styleSuff}`}>
        {offering.yield && !noShowFields.includes('yield') ? (
          <div styleName="offerStatContainer">
            <YieldLabel />
            <div styleName="yieldStat">{offering.yield || '--'}</div>
          </div>
        ) : null }
        <div styleName="offerStatContainer">
          <div styleName="minInv">Minimum Investment</div>
          {currency}
        </div>
        {nonFolio &&
        <div styleName="offerStatContainer nonFolioOffer flex-container">
          <div styleName="nonFolioInfoIcon" style={{ flexGrow: 2, backgroundColor: '#bdd1e2' }}>
            <img src={notice} alt="" style={{ maxWidth: '24px', marginBottom: '-5px' }} />
          </div>
          <div styleName="nonFlioText" style={{ flexGrow: 9 }} {...buttonize(this.handleDisclaimerDialog)} >
            This Offering is funded and held outside of your My IPO account.
          </div>
        </div> }
        {actionControl}
        { this.state.showDisclaimerDialog ? (
          <BaseModal onClose={() => this.handleDisclaimerDialog()}>
            <div styleName="dialogHeader">
              <button onClick={() => this.handleDisclaimerDialog()} type="button" styleName="dialogHeaderCloseBtn">
                <img width="12" src={CloseIcon} alt="icon" />
              </button>
            </div>
            <div styleName="dialogTitle">
              Disclaimer
            </div>
            <div styleName="dialogText" style={{ textAlign: 'left' }}>
              {offering.securityDeliveryInformationOptions.disclaimer}
            </div>
            <div styleName="dialogActions">
              <Button style={{ border: 'none', WebkitBoxShadow: 'none', boxShadow: 'none' }} onClick={() => this.handleDisclaimerDialog()}>
                Close
              </Button>
            </div>
          </BaseModal>
        ) : null }
      </div>
    );
  }
}

const OfferMain = ({ offering, layout, postCloseInvestmentsAllowedIn }) => {
  const {
    logoUrl,
    name,
    assets,
  } = offering;
  let styleSuff = '';
  let playBtnSize = 'medium';
  switch (layout) {
    case LAYOUT.TAB:
      styleSuff = 'Tab';
      playBtnSize = 'medium';
      break;
    case LAYOUT.MOB:
      styleSuff = 'Mob';
      playBtnSize = 'small';
      break;
    // no default
  }
  return (
    <div styleName="offerMain">
      {layout === LAYOUT.MOB ?
        <div styleName="topLabelWrapper">
          <div styleName={`offerName${styleSuff}`}>{<ComingSoonLabel offering={offering} />}</div>
        </div> : null}
      <div styleName="offerNameRow">
        {
          logoUrl ?
            <div styleName="logoContainer">
              <img styleName="logo" src={logoUrl} alt={`${name} logo`} />
            </div> :
            <div styleName="logoContainerDefault">
              <img styleName="logo" src={DefaultLogo} alt={`${name} logo`} />
            </div>
        }
        <div styleName={`offerName${styleSuff}`}>{name}</div>
        {
          layout < LAYOUT.MOB ? <div styleName={`offerName${styleSuff}`}>{<ComingSoonLabel offering={offering} />}</div> : null
        }
      </div>
      <div styleName={`videoRow${styleSuff}`}>
        <div styleName={`video${styleSuff}`}>
          <VideoOrImage
            asset={assets && assets[0]}
            playBtnSize={playBtnSize}
          />
        </div>
        {layout === LAYOUT.DESK ?
          <StatsAndInvest
            styleSuff={styleSuff}
            offering={offering}
            postCloseInvestmentsAllowedIn={postCloseInvestmentsAllowedIn}
          /> : null}
      </div>
      {layout !== LAYOUT.DESK ?
        <StatsAndInvest
          styleSuff={styleSuff}
          offering={offering}
          postCloseInvestmentsAllowedIn={postCloseInvestmentsAllowedIn}
        /> : null}
    </div>
  );
};

OfferMain.propTypes = {
  layout: PropTypes.number.isRequired,
  offering: PropTypes.shape({
    closeDate: PropTypes.string,
    name: PropTypes.string.isRequired,
    logoUrl: PropTypes.string,
    assets: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string,
      previewImageUrl: PropTypes.string,
      type: PropTypes.string,
      title: PropTypes.string,
    })),
    yield: PropTypes.string,
    minimumInvestCurrencyAmt: PropTypes.number,
  }).isRequired,
};

export default OfferMain;



// WEBPACK FOOTER //
// ./src/components/Offering/OfferMain.js